/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Achievement_ExplorerInputs */

const en_us2_achievement_explorer = /** @type {(inputs: Achievement_ExplorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorer`)
};

const pt_br2_achievement_explorer = /** @type {(inputs: Achievement_ExplorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorador`)
};

const es_419_achievement_explorer = /** @type {(inputs: Achievement_ExplorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorador`)
};

const pt_pt2_achievement_explorer = /** @type {(inputs: Achievement_ExplorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorador`)
};

const fr_fr2_achievement_explorer = /** @type {(inputs: Achievement_ExplorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorateur`)
};

const de_de2_achievement_explorer = /** @type {(inputs: Achievement_ExplorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entdecker`)
};

const it_it2_achievement_explorer = /** @type {(inputs: Achievement_ExplorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esploratore`)
};

/**
* | output |
* | --- |
* | "Explorer" |
*
* @param {Achievement_ExplorerInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const achievement_explorer = /** @type {((inputs?: Achievement_ExplorerInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Achievement_ExplorerInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_achievement_explorer(inputs)
	if (locale === "es-419") return es_419_achievement_explorer(inputs)
	if (locale === "pt-PT") return pt_pt2_achievement_explorer(inputs)
	if (locale === "fr-FR") return fr_fr2_achievement_explorer(inputs)
	if (locale === "de-DE") return de_de2_achievement_explorer(inputs)
	if (locale === "it-IT") return it_it2_achievement_explorer(inputs)
	return en_us2_achievement_explorer(inputs)
});
export { achievement_explorer as "achievement.explorer" }